import { render, staticRenderFns } from "./WsInfoCurrency.vue?vue&type=template&id=0cc4fc0b&"
import script from "./WsInfoCurrency.vue?vue&type=script&lang=js&"
export * from "./WsInfoCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports